import React from 'react';
import { Table, Tooltip } from 'antd';
import { withRouter } from 'react-router-dom';
import memoize from 'lodash/memoize';
import PropTypes from 'prop-types';
import './index.scss';
import ManIcon from '@/assets/images/standing-up-man-copy-14.svg';
import ManOnChairIcon from '@/assets/images/male-cartoon-on-wheel-chair-copy-15.svg';
import FireFighterIcon from '@/assets/images/group.svg';

const { Column } = Table;

const dataTableWrap = [
	{
		key: 'tableWrap',
		floor: 'Floor',
		remaining: 'Remaining',
		inRoute: 'In Route',
	},
];

//  evacuationUserType :
//  REGULAR_MOBILITY_TYPE = 0;
//  MOBILITY_IMPAIRED_PERSONS_TYPE = 1;
//  EMERGENCY_TYPE = 2;
const getCountByType = (stats, type, name) =>
	stats.filter(el => el.evacuationUserType === type)[0][name];
const getSumOfType = (stats, name) => {
	if (!stats) return 0;
	return stats.reduce(
		(acc, type) => (type[name] ? acc + type[name] : acc),
		0,
	);
};
const floorData = zones =>
	zones.map(zone => ({ key: zone.zoneId, floor: zone.zoneId }));
const memoizeFloorData = memoize(floorData);
const remainingData = (zones, zonesOnStart) => {
	if (zones && zones.length) {
		return zones.map((zone, i) => {
			const { evacuationStatsItems } = zone;
			const employee = getCountByType(
				evacuationStatsItems,
				0,
				'notMovedCount',
			);
			const disabled = getCountByType(
				evacuationStatsItems,
				1,
				'notMovedCount',
			);
			const emergency = getCountByType(
				zone.evacuationStatsItems,
				2,
				'notMovedCount',
			);
			const startNumbOfEmpl = zonesOnStart.length
				? getSumOfType(
						zonesOnStart[i].evacuationStatsItems,
						'notMovedCount',
				  )
				: getSumOfType(zones[i].evacuationStatsItems, 'notMovedCount');
			const totalNumbOfEmp = getSumOfType(
				evacuationStatsItems,
				'notMovedCount',
			);
			const percentsWorkingFloor = startNumbOfEmpl
				? Math.round((totalNumbOfEmp / startNumbOfEmpl) * 100)
				: 0;
			const percentsLeft = 100 - percentsWorkingFloor;
			return {
				key: zone.zoneId,
				employee,
				disabled,
				emergency,
				total: startNumbOfEmpl,
				left: percentsLeft,
			};
		});
	}
};
const memoizeRemainingData = memoize(remainingData);
const inRouteData = zones =>
	zones.map(zone => {
		const { evacuationStatsItems } = zone;
		// const totalInRoute = getSumOfType(
		// 	evacuationStatsItems,
		// 	'evacuatingCount',
		// );
		// const totalInWorkingFloor = getSumOfType(
		// 	evacuationStatsItems,
		// 	'notMovedCount',
		// );
		return {
			key: zone.zoneId,
			employee: getCountByType(
				zone.evacuationStatsItems,
				0,
				'evacuatingCount',
			),
			disabled: getCountByType(
				zone.evacuationStatsItems,
				1,
				'evacuatingCount',
			),
			emergency: getCountByType(
				zone.evacuationStatsItems,
				2,
				'evacuatingCount',
			),
			// left: totalInRoute === 0 && totalInWorkingFloor === 0 && 0,
			left: 100,
		};
	});
const memoizeInRouteData = memoize(inRouteData);
const COMPONENT_CSS_CLASSNAME = 'evacuation-zones-table';
const bemE = suffix => `${COMPONENT_CSS_CLASSNAME}__${suffix}`;

const Floor = React.memo(
	withRouter(({ zones, history, type, siteId }) => {
		return (
			<Table
				dataSource={memoizeFloorData(zones)}
				pagination={false}
				className={bemE('floor-table')}
				rowClassName={bemE('floor-table-row')}
			>
				<Column
					title=""
					dataIndex="floor"
					key="floor"
					align="center"
					render={(text, record) => (
						<div
							className={bemE(`floor ${type}`)}
							onClick={() =>
								type === 'evacuation' &&
								history.push(
									`/evacuation/roll-call/${siteId}/${text}`,
								)
							}
						>
							{text}
						</div>
					)}
				/>
			</Table>
		);
	}),
);

const Remaining = React.memo(({ text, zones, zonesOnStart }) => {
	return (
		<Table
			dataSource={memoizeRemainingData(zones, zonesOnStart)}
			pagination={false}
			className={bemE('remaining-table')}
			rowClassName={bemE('remaining-table-row')}
		>
			<Column
				title={() => (
					<div className={bemE('zone-icon-wrap')}>
						<Tooltip
							title={'Regular Mobility'}
							overlayClassName={'icon-tooltip'}
						>
							<img src={ManIcon} alt="Regular Mobility" />
						</Tooltip>
						<Tooltip
							title={'Mobility Impaired Persons'}
							overlayClassName={'icon-tooltip'}
						>
							<img
								src={ManOnChairIcon}
								alt="Mobility Impaired Persons"
							/>
						</Tooltip>
						<Tooltip
							title={'Emergency'}
							overlayClassName={'icon-tooltip'}
						>
							<img src={FireFighterIcon} alt="Emergency" />
						</Tooltip>
					</div>
				)}
				dataIndex="employee"
				key="employee"
				align="center"
				// colSpan="3"
				render={(text, row, index) => ({
					children: (
						<div>
							<span
								className={bemE('zone-progress')}
								style={{
									width: `${row.left}%`,
									visibility:
										row.left > 0 ? 'visible' : 'hidden',
									backgroundColor:
										row.left === 100
											? '#00ce7d'
											: 'rgba(0, 206, 125, 0.4)',
								}}
							/>
							<div className={bemE('zone-value-wrap')}>
								<span>{text}</span>
								<span>{row.disabled}</span>
								<span>{row.emergency}</span>
							</div>
						</div>
					),
				})}
			/>
		</Table>
	);
});
const InRoute = React.memo(({ text, zones }) => {
	return (
		<Table
			dataSource={memoizeInRouteData(zones)}
			pagination={false}
			className={bemE('inRoute-table')}
			rowClassName={bemE('inRoute-table-row')}
		>
			<Column
				title={() => (
					<div className={bemE('zone-icon-wrap')}>
						<Tooltip
							title={'Regular Mobility'}
							overlayClassName={'icon-tooltip'}
						>
							<img src={ManIcon} alt="Regular Mobility" />
						</Tooltip>
						<Tooltip
							title={'Mobility Impaired Persons'}
							overlayClassName={'icon-tooltip'}
						>
							<img
								src={ManOnChairIcon}
								alt="Mobility Impaired Persons"
							/>
						</Tooltip>
						<Tooltip
							title={'Emergency'}
							overlayClassName={'icon-tooltip'}
						>
							<img src={FireFighterIcon} alt="Emergency" />
						</Tooltip>
					</div>
				)}
				dataIndex="employee"
				key="firstName"
				align="center"
				render={(text, row, index) => ({
					children: (
						<div>
							<span
								className={bemE('zone-progress')}
								style={{
									width: '100%',
									visibility:
										row.left === 0 ? 'visible' : 'hidden',
									backgroundColor:
										row.left === 0 && '#00ce7d',
								}}
							/>
							<div className={bemE('zone-value-wrap')}>
								<span>{text}</span>
								<span>{row.disabled}</span>
								<span>{row.emergency}</span>
							</div>
						</div>
					),
				})}
			/>
		</Table>
	);
});

const EvacutionZonesTable = React.memo(
	({ zones, zonesOnStart, type, loading, siteId }) => (
		<div className={COMPONENT_CSS_CLASSNAME}>
			<Table
				dataSource={dataTableWrap}
				pagination={false}
				className={bemE('wrapper-table')}
				rowClassName={bemE('wrapper-table-row')}
				loading={loading}
			>
				<Column
					title="Floor"
					dataIndex="floor"
					key="floor"
					render={() => (
						<Floor zones={zones} type={type} siteId={siteId} />
					)}
				/>
				<Column
					title="Remaining"
					dataIndex="remaining"
					key="remaining"
					render={(text, record) => (
						<Remaining
							text={text}
							zones={zones}
							zonesOnStart={zonesOnStart}
						/>
					)}
				/>
				<Column
					title="In Route"
					dataIndex="inRoute"
					key="inRoute"
					render={(text, record) => (
						<InRoute text={text} zones={zones} />
					)}
				/>
			</Table>
		</div>
	),
);

EvacutionZonesTable.defaultProps = {
	zones: [],
};

EvacutionZonesTable.propTypes = {
	zones: PropTypes.array,
};

export default EvacutionZonesTable;



// WEBPACK FOOTER //
// ./src/pages/evacuation-demo/components/evacuation-zone-table/index.js